<template>
	<modal
		class="ui ui--loader"
		v-if="isOpen && (isLoaner || mode == 'all')"
		style="opacity:1; background-color:#ababab"
	>
		<ElementLoader :label="progressValue ? progressValue + ' %' : ''" />
		<ElementText
			v-if="packageSyncer.error"
			:content="packageSyncer.error"
			style="position: absolute; bottom: 2rem; left: 0; right: 0; text-align: center;"
		/>
		<ElementButton
			v-if="packageSyncer.error && isLoaner"
			name="restart"
			@click="restart"
			content="restart app"
		/>
	</modal>
</template>
<script>
import { getterTypes } from '../../types';
import { PACKAGE_SYNCER_MODES, PACKAGE_SYNCER_STATE } from '../../tools/consts';

import { mapState, mapGetters } from 'vuex';
import { mapStateNested } from '../../tools/helpers';

import { uiComponents } from '../../tools/viewState';
import { logger } from '../../tools/logger';
import { appExit } from '../../tools/JS2NativeInterface';
import UiBase from './base.vue';
export default {
	extends: UiBase,
	data() {
		return {
			name: uiComponents.uiLoader,
		};
	},
	computed: {
		...mapState(['viewState', 'styleTemplateURL', 'packageSyncer', 'isLoaner']),
		...mapGetters([getterTypes.packageSyncerPartState]),
		...mapStateNested('packageSyncer', ['currentAction', 'packagesProcessed', 'packagesTotal', 'mode']),
		label() {
			return this.packageSyncer.error && this.packageSyncer.error !== 'null'
				? this.packageSyncer.error
				: '';
		},
		partState() {
			return this[getterTypes.packageSyncerPartState](PACKAGE_SYNCER_MODES.all);
		},
		isOpen() {
			if (
				this.partState === PACKAGE_SYNCER_STATE.downloading ||
				this.partState === PACKAGE_SYNCER_STATE.waiting ||
				this.partState === PACKAGE_SYNCER_STATE.notDownloaded
			)
				return true;
			return false;
		},
		progressValue() {
			return Math.round((this.packagesProcessed * 100) / this.packagesTotal);
		},
	},
	methods: {
		restart() {
			logger.log('Restart App after Error occured');
			appExit();
		},
	},
};
</script>
